import { RadioButtonData } from 'src/components/atoms/RadioButton';
import { PlatformFeedbackCategory } from 'src/features/myWork/api';

export const FEEDBACK_MAX_LENGTH = 500;

// How long the "Feedback reported" screen shows before the analyst goes to My Work.
export const CONFIRMATION_DURATION_MS = 2400;

export const categoryOptions: (RadioButtonData & { value: PlatformFeedbackCategory })[] = [
  { value: 'document_will_not_load', label: "Document won't load", isChecked: false },
  { value: 'page_error', label: 'Page crashed or threw an error', isChecked: false },
  { value: 'functionality_broken', label: 'Functionality is broken', isChecked: false },
  { value: 'something_else', label: 'Something else', isChecked: false }
];

export const canCompleteOptions: RadioButtonData[] = [
  { value: 'yes', label: 'Yes, I can complete the review', isChecked: false },
  { value: 'no', label: 'No, I cannot complete the review', isChecked: false }
];
